<template>
  <div class="task-more-popover" ref="$container">
    <TirPmPopover ref="$popover" :custom-position="customPosition">
      <slot />
      <template #content>
        <div class="task-more-popover__content">
          <div class="task-more-popover__option" @click="copyTaskLink">
            <div class="task-more-popover__option-left">
              <ShareIcon />
            </div>
            <div class="task-more-popover__option-middle">Скопировать название и ссылку</div>
          </div>
          <template v-if="parentTaskId">
            <TirPmPopover
              class="task-more-popover__option-popover"
              ref="$confirmUnattachPopover"
              is-no-teleport
              disable-content-blur
              :custom-position="{
                left: '0rem',
                bottom: '0.313rem',
              }"
            >
              <div class="task-more-popover__option">
                <div class="task-more-popover__option-left">
                  <ConnectIcon />
                </div>
                <div class="task-more-popover__option-middle">Открепить родительскую задачу</div>
              </div>
              <template #content>
                <div class="task-more-popover__confirm-popover">
                  <span class="task-more-popover__confirm-popover-message">
                    Открепить родительскую задачу?
                  </span>
                  <div class="task-more-popover__confirm-popover-buttons">
                    <TirPmButton
                      :variant="TirPmButtonVariantEnum.PrimaryState"
                      :size="TirPmButtonSizeEnum.Small"
                      :is-loading="isLoadingUnattachButton"
                      @click.stop="unattachParentTask"
                    >
                      Открепить
                    </TirPmButton>
                    <TirPmButton
                      :variant="TirPmButtonVariantEnum.SecondaryState"
                      :size="TirPmButtonSizeEnum.Small"
                      :is-disabled="isLoadingUnattachButton"
                      @click.stop="$confirmUnattachPopover?.close()"
                    >
                      Отмена
                    </TirPmButton>
                  </div>
                </div>
              </template>
            </TirPmPopover>
            <TaskSubtasksSearchDropdown
              :search-function="searchTasksFunction"
              :custom-popover-position="customPosition"
              no-teleport
              disable-content-blur
              close-by-select
              @on-select="changeParentTask"
            >
              <template #target>
                <div class="task-more-popover__option">
                  <div class="task-more-popover__option-left">
                    <ConnectIcon />
                  </div>
                  <div class="task-more-popover__option-middle">Сменить родительскую задачу</div>
                  <div class="task-more-popover__option-right">
                    <svg
                      class="task-more-popover__option-svg-icon"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.21967 7.21967C9.51256 6.92678 9.98744 6.92678 10.2803 7.21967L14.5303 11.4697C14.671 11.6103 14.75 11.8011 14.75 12C14.75 12.1989 14.671 12.3897 14.5303 12.5303L10.2803 16.7803C9.98744 17.0732 9.51256 17.0732 9.21967 16.7803C8.92678 16.4874 8.92678 16.0126 9.21967 15.7197L12.9393 12L9.21967 8.28033C8.92678 7.98744 8.92678 7.51256 9.21967 7.21967Z"
                      />
                    </svg>
                  </div>
                </div>
              </template>
            </TaskSubtasksSearchDropdown>
          </template>
          <TaskSubtasksSearchDropdown
            v-if="!parentTaskId && editing"
            :queueId="queueId"
            :search-function="searchTasksFunction"
            :custom-popover-position="customPosition"
            no-teleport
            disable-content-blur
            closeBySelect
            @on-select="attachParentTask"
          >
            <template #target>
              <div class="task-more-popover__option">
                <div class="task-more-popover__option-left">
                  <ConnectIcon />
                </div>
                <div class="task-more-popover__option-middle">Назначить родительскую задачу</div>
                <div class="task-more-popover__option-right">
                  <svg
                    class="task-more-popover__option-svg-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.21967 7.21967C9.51256 6.92678 9.98744 6.92678 10.2803 7.21967L14.5303 11.4697C14.671 11.6103 14.75 11.8011 14.75 12C14.75 12.1989 14.671 12.3897 14.5303 12.5303L10.2803 16.7803C9.98744 17.0732 9.51256 17.0732 9.21967 16.7803C8.92678 16.4874 8.92678 16.0126 9.21967 15.7197L12.9393 12L9.21967 8.28033C8.92678 7.98744 8.92678 7.51256 9.21967 7.21967Z"
                    />
                  </svg>
                </div>
              </div>
            </template>
          </TaskSubtasksSearchDropdown>
          <TirPmRouterLink
            :isDisabled="!props.taskId"
            :to="openSchema"
            class="task-more-popover__option"
            v-if="editing"
          >
            <div class="task-more-popover__option-left">
              <MapIcon />
            </div>
            <div class="task-more-popover__option-middle">Посмотреть карту проекта</div>
          </TirPmRouterLink>
          <div class="task-more-popover__option" @click="openCopyModal">
            <div class="task-more-popover__option-left">
              <PencilSquareIcon />
            </div>
            <div class="task-more-popover__option-middle">Скопировать тикет в другую очередь</div>
          </div>
          <div class="task-more-popover__option" @click="openTransferModal(taskId)">
            <div class="task-more-popover__option-left">
              <ArrowUpRightIcon />
            </div>
            <div class="task-more-popover__option-middle">Перенести тикет в другую очередь</div>
          </div>
          <PerformerListByOrder
            v-if="accessAddQueue"
            :taskInfo="task"
            @closePopover="$popover.close()"
          />
          <div v-if="showRemove" class="task-more-popover__option red" @click="removeTask">
            <div class="task-more-popover__option-left">
              <TrashIcon />
            </div>
            <div class="task-more-popover__option-middle">Удалить тикет</div>
          </div>
        </div>
      </template>
    </TirPmPopover>
  </div>
  <TaskCopyingModal
    ref="$taskCopyingModal"
    :task-id="taskId"
    :isParentalTask="isParentalTask"
    :attachedQueues="attachedQueues"
    :isSubtasks="isSubtasks"
  />
  <TaskTransferModal
    ref="$taskTransferModal"
    :projectId="projectId"
    :task-id="taskId"
    :isParentalTask="isParentalTask"
    :attachedQueues="attachedQueues"
    :isSubtasks="isSubtasks"
    @transferTask="transferTaskEvent"
  />
  <RemoveTaskModal
    ref="$removeTaskModal"
    :timerTrackerRecords="timerTrackerRecords"
    :transferTask="transferTask"
    @successRemove="successRemove"
  />
</template>

<script lang="ts" setup>
import { computed, inject, onMounted, onUnmounted, PropType, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import {
  TirPmPopover,
  PopoverPositionType,
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmRouterLink,
} from 'tir-components';
import {
  ConnectIcon,
  ShareIcon,
  MapIcon,
  PencilSquareIcon,
  TrashIcon,
  ArrowUpRightIcon,
} from 'tir-style-system/icons/outline';
import {
  SubtasksSearchFunctionType,
  TaskSubtasksSearchDropdown,
} from '../task-subtasks-search-dropdown';
import { TaskCopyingModal, RemoveTaskModal, TimeTrackerRecordModel } from '@/components';
import PerformerListByOrder from '@/components/tasks-kanban/components/PerformerListByOrder.vue';
import { TaskModel } from '@/components/tasks-kanban/models';
import { SubtaskModel } from '../../models';
import { TaskTransferModal } from '../task-transfer-modal';
import GetAccessCurrentUserInQueueTaskByIdResponseModel from './models/GetAccessCurrentUserInQueueTaskByIdResponseModel';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';

const router = useRouter();

/**Параметры */
const props = defineProps({
  /**ID очереди */
  queueId: { type: String },
  /**Доступы юзера к очереди */
  userAccess: { type: Object as PropType<GetAccessCurrentUserInQueueTaskByIdResponseModel> },
  /**Открыть в виде шторки */
  showAsDrawer: { type: Boolean, default: false },
  /**Подзадачи */
  subtasks: { type: Array as PropType<SubtaskModel[]> },
  /**наличие подзадач */
  isSubtasks: { type: Boolean },
  /**Прикрепленные очереди */
  attachedQueues: { type: Boolean },
  /**Записи таймера */
  timerTrackerRecords: {
    type: Array as PropType<Array<TimeTrackerRecordModel>>,
    default: [],
  },
  /**Задача */
  task: {
    type: Object as PropType<TaskModel>,
    required: true,
  },
  /**Родительская задача */
  isParentalTask: { type: Boolean },
  /**Id задачи */
  taskId: { type: Number, required: true },
  /**ID проекта */
  projectId: { type: Number, required: true },
  /**Имя задачи */
  taskName: { type: String, required: true },
  /**Режим редактирования */
  editing: {
    type: Boolean,
    default: true,
  },
  /**ID родительской задачи */
  parentTaskId: {
    type: Number,
  },
  /**Кастомная позиция поповера */
  customPosition: {
    type: Object as PropType<PopoverPositionType>,
    default: (): PopoverPositionType => ({
      right: '0rem',
      top: '$el:height + 0.25rem',
    }),
  },
  /**Функция поиска задач */
  searchTasksFunction: {
    type: Function as PropType<SubtasksSearchFunctionType>,
    required: true,
  },
  /**Загрузка при откреплении задачи */
  isLoadingUnattachButton: {
    type: Boolean,
    default: false,
  },
  /**Показывать ли удаление */
  showRemove: { type: Boolean },
});
/**События */
const emit = defineEmits<{
  /**Событие для прикрепления родительской задачи */
  (e: 'attachParentTask', parentTaskId: number): void;
  /**Событие для открепления родительской задачи */
  (e: 'unattachParentTask'): void;
  /**Событие для смены родительской задачи */
  (e: 'changeParentTask', parentTaskId: number): void;
  /**Событие копирования ссылки на задачу */
  (e: 'copyTaskLink'): void;
  /**Успешное удаление задачи */
  (e: 'successRemove'): void;
  /**перенос задачи */
  (e: 'transferTask'): void;
}>();

/**Является ли текущий юзер овнером */
const isOwner = CurrentUser.Roles.includes(UserRoleEnum.Owner);

/**Окно для копирования задачи */
const $taskCopyingModal = ref<InstanceType<typeof TaskCopyingModal>>();
/**Окно для переноса задачи */
const $taskTransferModal = ref<InstanceType<typeof TaskTransferModal>>();
const $popover = ref<InstanceType<typeof TirPmPopover>>();
const transferTask = ref<boolean>();

const $container = ref<HTMLElement>();

const $confirmUnattachPopover = ref<InstanceType<typeof TirPmPopover>>();
/**Окно для удаления задачи */
const $removeTaskModal = ref<InstanceType<typeof RemoveTaskModal>>();

const pageScrollSelector = inject<string | undefined>('popover-scroll-selector');
let pageScrollElement: HTMLElement | undefined;

/**Доступ к добавлению задачи в очередность исполнителя */
const accessAddQueue = computed(() => props.userAccess.CanCustomizeOrder || isOwner);

onMounted(() => {
  pageScrollElement = pageScrollSelector && $container.value?.closest(pageScrollSelector);
  pageScrollElement?.addEventListener('scroll', onScroll);
});
onUnmounted(() => {
  pageScrollElement?.removeEventListener('scroll', onScroll);
});

const onScroll = () => {
  $confirmUnattachPopover.value?.close();
};

const attachParentTask = (value) => {
  emit('attachParentTask', value);
  $popover.value?.close();
};

const unattachParentTask = () => {
  emit('unattachParentTask');
  $popover.value?.close();
};

const changeParentTask = (value) => {
  emit('changeParentTask', value);
  $popover.value?.close();
};

const copyTaskLink = () => {
  emit('copyTaskLink');
  $popover.value?.close();
};
/**Открыть карту проекта */
const openSchema = computed(() => {
  return router.resolve({
    name: 'project-map',
    params: {
      taskId: props.taskId,
      projectId: props.projectId,
    },
  });
});
/**Подтвержденное удаление задачи */
const successRemove = () => {
  emit('successRemove');
};
/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};
/**Открытие окна для копирования задачи */
const openCopyModal = () => {
  $popover.value?.close();
  $taskCopyingModal.value?.toggle(true);
};
/**Открытие окна для переноса задачи */
const openTransferModal = (taskId: number) => {
  $popover.value?.close();
  if (props.subtasks?.length || props.task.Parent || props.task.QueueToTaskRelationList.length) {
    addNotification('Невозможно перенести тикет с родительским/дочерними тикетами', true);
  } else {
    $taskTransferModal.value?.toggle(true, taskId);
  }
};

/**Перенос задачи */
const transferTaskEvent = () => {
  emit('transferTask');
};

/**Открыть окно для подтверждения удаления задачи */
const removeTask = () => {
  $popover.value?.close();
  $removeTaskModal.value?.open(props.taskId, props.taskName);
};
</script>

<style lang="scss" scoped>
.task-more-popover {
  &__content {
    background-color: var(--bg-base, #fff);
    border-radius: 0.5rem;
    border: 0.063rem solid var(--neutral-10, #eaeaeb);
    overflow: hidden;
    .tir-pm-multiselect {
      width: 100%;
    }
  }
  &__option {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    background-color: var(--bg-base, #fff);
    color: var(--text-primary, #272d37);
    transition: background-color 0.2s ease-in-out;
    width: 100%;
    cursor: pointer;

    &:hover {
      background-color: var(--neutral-translucent-5, rgba(39, 45, 55, 0.05));
    }
    &:active {
      background-color: var(--neutral-translucent-10, rgba(39, 45, 55, 0.1));
    }

    &.red {
      &,
      .task-more-popover__option-middle {
        color: var(--text-negative);
      }
    }
  }
  &__option-left {
    width: 1.5rem;
    height: 1.5rem;
  }
  &__option-right {
    width: 1.5rem;
    height: 1.5rem;
    margin-left: auto;
  }
  &__option-middle {
    color: var(--text-primary, #272d37);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
  }
  &__option-svg-icon {
    path {
      fill: var(--text-primary, #272d37);
    }
  }
  &__confirm-popover {
    border-radius: 0.5rem;
    background: var(--bg-base, #fff);
    padding: var(--12, 0.75rem);
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  &__confirm-popover-message {
    color: var(--text-primary, #272d37);
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
  }
  &__confirm-popover-buttons {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  &__animation-enter-active,
  &__animation-leave-active {
    transition: 0.3s;
    opacity: 1;
  }
  &__animation-enter-from,
  &__animation-leave-to {
    transition: 0.3s;
    opacity: 0;
  }
}
</style>

<style lang="scss">
.task-more-popover__option-popover {
  &.tir-popover_element {
    display: block;
    width: 100% !important;
  }
}
</style>
